import { initBirdie } from '@birdie-so/snippet';
import { useEffect } from 'react';

export const useBirdie = () => {
  useEffect(() => {
    // Prevent initialization on localhost
    if (window.location.hostname === 'localhost') {
      return;
    }

    initBirdie({
      clientId: window.__env__.BIRDIE_CLIENT_ID
    });
  }, []);
};
